import { hasShell, tellShell } from '../lib/shell'
import type { WorkspaceRecovery } from './protocol'

/** The native window must hold the recovery marker before an irreversible request
 * leaves the renderer. Posting the bridge message alone does not order HTTP. */
export class RecoveryCheckpoints {
  private readonly waiting = new Map<string, { tab: string; finish(accepted: boolean): void }>()
  private readonly heard = (event: Event) => {
    const detail: unknown = (event as CustomEvent).detail
    if (!detail || typeof detail !== 'object' || !('id' in detail) || !('accepted' in detail)
      || typeof detail.id !== 'string' || typeof detail.accepted !== 'boolean') return
    this.waiting.get(detail.id)?.finish(detail.accepted)
  }
  constructor() { window.addEventListener('poulpe-workspace-checkpoint', this.heard) }
  save(tab: string, recovery: WorkspaceRecovery | null): Promise<boolean> {
    if (!hasShell()) return Promise.resolve(true)
    if (!recovery) return Promise.resolve(false)
    const id = crypto.randomUUID()
    return new Promise(resolve => {
      const finish = (accepted: boolean) => {
        if (!this.waiting.delete(id)) return
        clearTimeout(timer)
        resolve(accepted)
      }
      // A missing response is a failed checkpoint, never permission to send.
      const timer = setTimeout(() => finish(false), 15_000)
      this.waiting.set(id, { tab, finish })
      try {
        tellShell({ workspaceState: recovery.state })
        tellShell({ workspaceCheckpoint: { id, recovery } })
      } catch { finish(false) }
    })
  }
  cancel(tab?: string) {
    for (const entry of [...this.waiting.values()]) if (tab === undefined || entry.tab === tab) entry.finish(false)
  }
  dispose() { this.cancel(); window.removeEventListener('poulpe-workspace-checkpoint', this.heard) }
}
